import type { WorkshopCard } from '../../data/lacEpauleSeptembre2026Data';
// Neutral metadata only. Financial content must never be prepared or persisted here.
export const FINANCE_FD_ID = 'ce-finance-fd-2026';
export const financeFDCard: WorkshopCard = {
  id: FINANCE_FD_ID, title: 'Finance · consultation FD', family: 'Finance & gouvernance', importance: 'élevée', ownerIds: ['db'],
  tags: ['finance', 'FD'], summary: 'Ouvrir la consultation privée autorisée.', whyNow: 'Support de discussion du comité.',
  enrichedContext: [], questions: [], decisions: [], signals: [], evidence: [], position: { x: 60, y: 76, rotate: 1 },
};
